import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TestCaseStatus } from "../Types/SanityCheck.types";

interface State {
    selectedTestCaseId: string;
    testCaseStatus: TestCaseStatus;
    lastRunJobId: string;
}

const initialState: State = {
    selectedTestCaseId: '',
    testCaseStatus: TestCaseStatus.NotRun,
    lastRunJobId: '',
}

const sanityCheckSlice = createSlice({
    name: 'sanityCheck',
    initialState,
    reducers: {
        setTestCaseStatus(state, action: PayloadAction<TestCaseStatus>): any {
            return { ...state, testCaseStatus: action.payload };
        },
        setSelectedTestCaseId(state, action: PayloadAction<string>): any {
            return { ...state, selectedTestCaseId: action.payload };
        },
        setLastRunJobId(state, action: PayloadAction<string>): any {
            return { ...state, lastRunJobId: action.payload };
        }
    },
});

export const { setTestCaseStatus, setSelectedTestCaseId, setLastRunJobId } = sanityCheckSlice.actions;
export default sanityCheckSlice.reducer;
